import React from "react";
import "./DriverSignature.css";
import { Typography } from "@material-ui/core";
import { useTranslate } from "react-admin";

interface DriverSignatureProps {
  record: any;
}

export const DriverSignature = ({ record }: DriverSignatureProps) => {
  const translate = useTranslate();
  return (
    <div id="driver-signature-container">
      <Typography variant="h6">
        {translate("resources.hos-driver-log-view.labels.driverSignature")}
      </Typography>
      {record.certified ? (
        <img src={record.signature} alt="Signature" />
      ) : (
        <Typography variant="body2">
          {translate("resources.hos-driver-log-view.labels.notCertified")}
        </Typography>
      )}
    </div>
  );
};
